import {
  ViewController,
  NavParams,
  NavController,
  LoadingController,
  AlertController,
  PopoverController
} from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import * as ics from 'ics';

import { JobsProvider } from './../../providers/jobs/jobs';
import { StaffProvider } from './../../providers/staff/staff';
import { NotificationsProvider } from './../../providers/notifications/notifications';

import {
  IJob,
  IJobStaff,
  IStaffTypeApplications,
  IJobCalendarEvent,
  IJobCalendarDate,
  IJobCalendarDuration,
  JobApplicationStatus
} from './../../interfaces/jobs';
import { IStaffType } from '../../interfaces/staff';
import { IUser } from './../../interfaces/users';
import { INotification } from './../../interfaces/notifications';
import { IPayment } from '../../interfaces/payment';

import { MyJobsPage } from './../../pages/my-jobs/my-jobs';
import { UserInfoComponent } from './../../shared/user/user-info';
import { RatingCreateComponent } from './../rating/rating-create';
import { PaymentComponent } from './../payment/payment';

@Component({
  selector: 'job-info',
  templateUrl: 'job-info.html'
})
export class JobInfoComponent implements OnInit, OnDestroy {
  job: IJob;
  jobSubscription: any;
  jobDataLoaded = false;
  currentUser: IUser;
  hasApplied = false;
  canStartJob = false;
  canEndJob = false;
  canClockIn = false;
  canClockOut = false;
  canCancel = true;
  // userJobs: IJobStaff[];
  userJob: IJobStaff;
  userJobsSubscription: any;
  userJobsDataLoaded = false;

  jobStaff: IJobStaff[];
  jobStaffSubscription: any;
  jobStaffDataLoaded = false;
  hasStaff = false;

  staffTypesSubscription: any;
  staffTypes: IStaffType[] = [];

  applicationTypeForm: FormGroup;
  applicationTypeFormSubmitted = false;

  //jobApplications: IJobApplication[];

  loader;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private http: HttpClient,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private jobsProvider: JobsProvider,
    private staffProvider: StaffProvider,
    private notificationsProvider: NotificationsProvider
  ) {
    //this.job = this.navParams.data.job;
    this.currentUser = this.navParams.data.user;
    this.createApplicationTypeForm();
  }

  ngOnInit() {
    console.log(this.job);
    this.loadJob(this.navParams.data.job.id);
  }

  ngOnDestroy() {
    if (this.userJobsSubscription) {
      this.userJobsSubscription.unsubscribe();
    }
    if (this.jobStaffSubscription) {
      this.jobStaffSubscription.unsubscribe();
    }
    if (this.staffTypesSubscription) {
      this.staffTypesSubscription.unsubscribe();
    }
  }

  loadJob(jobId: string) {
    this.loader = this.loadingCtrl.create({
      content: 'Loading job details...'
    });
    this.loader.present();

    this.jobSubscription = this.jobsProvider.getJobDetails(jobId).subscribe(
      data => {
        this.job = data;
        this.loadUserJobs();
        return data;
      },
      err => {
        console.log(err);
      }
    );
  }

  loadUserJobs() {
    this.userJobsSubscription = this.jobsProvider
      .getUserJobs(this.currentUser.uid)
      .subscribe(
        data => {
          data.forEach(userJob => {
            console.log('--- job id ---');
            console.log(this.job);

            console.log('--- user job ---');
            console.log(userJob.jobId);

            if (this.job.id === userJob.jobId) {
              console.log('user has applied for this job');
              this.hasApplied = true;
              this.userJob = userJob;
              console.log(this.userJob);

              if (
                moment().isAfter(
                  moment(this.job.start).subtract(30, 'minute')
                ) &&
                moment().isBefore(moment(this.job.end)) &&
                this.userJob.status === JobApplicationStatus.Accepted
              ) {
                this.canClockIn = true;
                this.canCancel = false;
              } else {
                this.canClockIn = false;
                if (this.userJob.status === JobApplicationStatus.Declined) {
                  this.canCancel = false;
                }
              }
              if (this.userJob.status >= 3) {
                this.canCancel = false;
                if (this.userJob.status === JobApplicationStatus.ClockInConfirmed) {
                  this.canClockOut = true;
                } else {
                  this.canClockOut = false;
                }
                if (
                  this.userJob.status === JobApplicationStatus.Declined ||
                  this.userJob.status === JobApplicationStatus.ClockInConfirmed ||
                  this.userJob.status === JobApplicationStatus.ClockedOut ||
                  this.userJob.status === JobApplicationStatus.Completed ||
                  this.userJob.status === JobApplicationStatus.Rated
                ) {
                  this.canClockIn = false;
                }

              }
            }
          });
          this.userJobsDataLoaded = true;
          console.log('userJobsDataLoaded');
          this.loader.dismiss();
        },
        err => {
          console.log(err);
        }
      );

    if (this.currentUser.regType === 'recruiter') {
      this.jobStaffSubscription = this.jobsProvider
        .getJobStaff(this.job.id)
        .subscribe(
          data => {
            console.log('--- job staff ---');
            //console.log(data);
            data.forEach(jobStaff => {
              console.log(jobStaff);
            });
            this.jobStaff = data;

            if (this.jobStaff.length > 0) {
              this.hasStaff = true;
            }

            if (
              moment().isAfter(moment(this.job.start).subtract(30, 'minute')) &&
              this.job.paymentStatus === 1 &&
              this.job.status < 2
            ) {
              this.canStartJob = true;
            }

            if (
              moment().isAfter(moment(this.job.end)) &&
              this.job.paymentStatus === 1 &&
              this.job.status === 2
            ) {
              this.canEndJob = true;
            }

            this.jobStaffDataLoaded = true;
            return data;
          },
          err => {
            console.log(err);
          }
        );
    }

    this.staffTypesSubscription = this.staffProvider.getStaffTypes().subscribe(
      data => {
        this.staffTypes = data;
        return data;
      },
      err => {
        console.log(err);
      }
    );
  }

  getStaffTypeCounts(staffTypeId: string) {
    let typeHasApplications = this.jobStaff.find(
      js => js.applicationType.id === staffTypeId
    );
    let staffTypeApplications: IStaffTypeApplications;
    let requiredStaff = this.job.staff.find(
      j => j.staffType.id === staffTypeId
    );

    if (typeHasApplications) {
      let jobStaff = this.jobStaff.filter(
        js => js.applicationType.id === staffTypeId
      );
      let jobStaffPending = jobStaff.filter(js => js.status === JobApplicationStatus.Pending);
      let jobStaffConfirmed = jobStaff.filter(js => js.status === JobApplicationStatus.Accepted);
      let jobStaffDeclined = jobStaff.filter(js => js.status === JobApplicationStatus.Declined);
      let jobStaffClocks = jobStaff.filter(js => js.status > 2);


      staffTypeApplications = {
        staffType: jobStaff[0].applicationType,
        pending: jobStaffPending.length,
        declined: jobStaffDeclined.length
      };
      if (jobStaffClocks.length > 0) {
        staffTypeApplications.confirmed =
          jobStaffConfirmed.length + jobStaffClocks.length;
        staffTypeApplications.remaining =
          requiredStaff.quantity -
          (jobStaffConfirmed.length + jobStaffClocks.length);
      } else {
        staffTypeApplications.confirmed = jobStaffConfirmed.length;
        staffTypeApplications.remaining =
          requiredStaff.quantity - jobStaffConfirmed.length;
      }
    } else {
      staffTypeApplications = {
        confirmed: 0,
        pending: 0,
        declined: 0,
        remaining: requiredStaff.quantity
      };
    }

    return staffTypeApplications;
  }

  acceptJob(id: string) {
    this.applicationTypeFormSubmitted = true;

    let loader = this.loadingCtrl.create({
      content: 'Saving job application...'
    });
    loader.present();

    let alert = this.alertCtrl.create({
      title: 'Application successful!',
      message:
        'Your application has been saved against this job. This job can be found in the "My Diary" page. You will be sent a notification for any updates to this job',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            console.log('Ok clicked');
            this.viewCtrl.dismiss();
            this.applicationTypeFormSubmitted = true;
          }
        }
      ]
    });

    if (moment().isSameOrAfter(moment(this.job.end))) {
      let isOverAlert = this.alertCtrl.create({
        title: 'Job is over!',
        message:
          'You cannot apply for a job that is already over',
        buttons: [
          {
            text: 'Ok',
            role: 'cancel',
            handler: () => {
              console.log('Ok clicked');
              this.viewCtrl.dismiss();
              this.applicationTypeFormSubmitted = true;
            }
          }
        ]
      });

      loader.dismiss();
      isOverAlert.present();

      return;
    }

    if (this.applicationTypeForm.valid) {
      console.log(id);
      const jobStaff: IJobStaff = {
        jobId: id,
        userId: this.currentUser.uid,
        applicationType: this.staffTypes.find(
          st => st.id === this.applicationTypeForm.value.applicationType
        )
      };
      this.jobsProvider
        .createJobStaff(jobStaff)
        .then(() => {
          //this.navCtrl.setRoot(MyJobsPage);
          loader.dismiss();
          alert.present();

          const notification: INotification = {
            title: 'Staff application',
            message: `${this.currentUser.firstName} ${this.currentUser.lastName} has applied for the position of ${jobStaff.applicationType.title}.`,
            icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
            component: 'job',
            item: this.job.id,
            status: 0
          };

          this.notificationsProvider.createNotification(
            this.job.createdBy,
            notification
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  cancelApplication() {
    let alert = this.alertCtrl.create({
      title: 'Confirm cancellation',
      message: 'Are you sure you want to cancel your application for this job?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            console.log('No clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Yes clicked');
            this.processCancellation();
          }
        }
      ]
    });
    alert.present();
  }

  processCancellation() {
    let loader = this.loadingCtrl.create({
      content: 'Cancelling application...'
    });
    loader.present();
    this.jobsProvider
      .deleteJobApplication(this.job.id, this.currentUser.uid)
      .then(() => {
        console.log('Job application cancelled');
        const notification: INotification = {
          title: 'Staff cancelled',
          message: `${this.currentUser.firstName} ${this.currentUser.lastName} has cancelled their appointment.`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: 'job',
          item: this.job.id,
          status: 0
        };

        this.notificationsProvider.createNotification(
          this.job.createdBy,
          notification
        );
        loader.dismiss();
        this.viewCtrl.dismiss();
      });
  }

  clockIn(jobId: string) {
    let loader = this.loadingCtrl.create({
      content: 'Clocking in...'
    });
    loader.present();
    console.log(
      `going to clock in user: ${this.currentUser.uid} to job: ${jobId}`
    );
    this.jobsProvider
      .updateJobApplication(jobId, this.currentUser.uid, JobApplicationStatus.ClockedIn)
      .then(() => {
        console.log('Staff Clocked In');
        //TODO: send recruiter a notification to notify that xxx has clocked in
        const notification: INotification = {
          title: 'Staff clocked in',
          message: `${this.currentUser.firstName} ${this.currentUser.lastName} has checked in. Please confirm their clock in.`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: 'job',
          item: this.job.id,
          status: 0
        };

        this.notificationsProvider.createNotification(
          this.job.createdBy,
          notification
        );
        this.canClockIn = false;
        loader.dismiss();
      });
  }

  clockOut(jobId: string) {
    let loader = this.loadingCtrl.create({
      content: 'Clocking out...'
    });
    loader.present();
    console.log(
      `going to clock out user: ${this.currentUser.uid} to job: ${jobId}`
    );
    this.jobsProvider
      .updateJobApplication(jobId, this.currentUser.uid, JobApplicationStatus.ClockedOut)
      .then(() => {
        console.log('Staff Clocked Out');
        // TODO: run some sort of a check to see if all candidates have clocked out... and if so then set the job status to complete
        const notification: INotification = {
          title: 'Staff clocked out',
          message: `${this.currentUser.firstName} ${this.currentUser.lastName} has clocked out.`,
          component: 'job',
          item: this.job.id,
          status: 0
        };

        this.notificationsProvider.createNotification(
          this.job.createdBy,
          notification
        );
        this.canClockOut = false;
        loader.dismiss();
      });
  }

  confirmClockIn(candidate: IJobStaff) {
    let loader = this.loadingCtrl.create({
      content: 'Clocking in...'
    });
    loader.present();
    console.log(
      `going to clock in user: ${candidate.userId} to job: ${this.job.id}`
    );
    this.jobsProvider
      .updateJobApplication(this.job.id, candidate.userId, JobApplicationStatus.ClockInConfirmed)
      .then(() => {
        console.log('Staff Clocked In');

        const notification: INotification = {
          title: 'Clocked in',
          message: `${this.currentUser.firstName} ${this.currentUser.lastName} has confirmed you clock in.`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: 'job',
          item: this.job.id,
          status: 0
        };

        this.notificationsProvider.createNotification(
          candidate.userId,
          notification
        );

        loader.dismiss();
      });
  }

  confirmClockOut(candidate: IJobStaff) {
    let loader = this.loadingCtrl.create({
      content: 'Clocking out...'
    });
    loader.present();
    console.log(
      `going to clock out user: ${candidate.userId} to job: ${this.job.id}`
    );
    this.jobsProvider
      .updateJobApplication(this.job.id, candidate.userId, JobApplicationStatus.Completed)
      .then(() => {
        console.log('Staff Clocked In');

        const notification: INotification = {
          title: 'Clocked out',
          message: `${this.currentUser.firstName} ${this.currentUser.lastName} has confirmed their clock out.`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: 'job',
          item: this.job.id,
          status: 0
        };

        this.notificationsProvider.createNotification(
          this.job.id,
          notification
        );

        loader.dismiss();
      });
  }

  payJob(job: IJob) {
    console.log(`About to pay for job: ${job.id}`);

    const total = Math.round(job.total * 100) / 100;
    let amount = parseFloat(total.toString()).toFixed(2);

    const paymentData: IPayment = {
      merchant_id: '13104302', // live: 13104302  |  sandbox: 10012454
      merchant_key: 'k1wbd9pud1wgt', // live: k1wbd9pud1wgt  |  sandbox: 04slorg7c71hd
      m_payment_id: this.job.id,
      return_url: 'https://us-central1-joboxapps.cloudfunctions.net/success',
      cancel_url: 'https://us-central1-joboxapps.cloudfunctions.net/cancel',
      notify_url: 'https://us-central1-joboxapps.cloudfunctions.net/notify',
      name_first: this.currentUser.firstName,
      name_last: this.currentUser.lastName,
      email_address: this.currentUser.email,
      cell_number: this.currentUser.cellphone.replace('+27', '0'),
      amount: amount,
      item_name: 'Jobox Job',
      item_description: `Jobox Job - ${this.job.id}`
    };

    let payment = '';
    Object.keys(paymentData).forEach(key => {
      console.log(key);
      console.log(paymentData[key]);
      payment += `${key}=${paymentData[key]
        .replace(/ /g, '+')
        .replace(/@/g, '%40')}&`;
    });
    payment = payment.slice(0, -1);
    console.log(payment);

    window.open(`https://www.payfast.co.za/eng/process?${payment}`, '_blank');
  }

  createApplicationTypeForm() {
    this.applicationTypeForm = this.formBuilder.group({
      applicationType: ['', Validators.compose([Validators.required])]
    });
  }

  startJob(jobId: string) {
    let loader = this.loadingCtrl.create({
      content: 'Starting job...'
    });
    loader.present();
    this.jobsProvider.startJob(jobId).then(() => {
      console.log('Job started');

      this.jobStaff.forEach(staff => {
        if (staff.status === 1) {
          const notification: INotification = {
            title: 'Job started',
            message: `${this.currentUser.firstName} ${this.currentUser.lastName} has started the job ${this.job.name}. Please make sure you clock in.`,
            icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
            component: 'job',
            item: this.job.id,
            status: 0
          };

          this.notificationsProvider.createNotification(
            staff.userId,
            notification
          );
        }
      });

      this.canStartJob = false;

      loader.dismiss();
      this.viewCtrl.dismiss();
    });
  }

  endJob(jobId: string) {
    let loader = this.loadingCtrl.create({
      content: 'Ending job...'
    });
    loader.present();
    this.jobsProvider.completeJob(jobId).then(() => {
      console.log('Job ended');

      this.jobStaff.forEach(staff => {
        if (staff.status === 4 || staff.status === 3) {
          this.jobsProvider
            .updateJobApplication(this.job.id, staff.userId, 5)
            .then(() => {
              // TODO: do something here... not sure what though :/
            })
            .catch(err => {
              console.log(err);
            });

          const notification: INotification = {
            title: 'Job ended',
            message: `${this.currentUser.firstName} ${this.currentUser.lastName} has ended the job ${this.job.name}. Please make sure you confirm clock out to mark the job as complete. To ensure payment please go to your User Profile and make sure your Bank Details are up-to-date. You should receive payment within 14 days of this clock-out notification.`,
            icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
            component: 'job',
            item: this.job.id,
            status: 0
          };

          this.notificationsProvider.createNotification(
            staff.userId,
            notification
          );
        }
      });

      this.canEndJob = false;

      loader.dismiss();
      this.viewCtrl.dismiss();
    });
  }

  openCandidate(candidate: IJobStaff) {
    console.log(candidate);
    let popover = this.popoverCtrl.create(
      UserInfoComponent,
      { job: this.job, candidate: candidate, user: this.currentUser },
      {
        showBackdrop: true,
        enableBackdropDismiss: true,
        cssClass: 'user-popover'
      }
    );
    popover.present({
      ev: candidate
    });
  }

  openRating(candidate: IJobStaff) {
    console.log(candidate);
    let popover = this.popoverCtrl.create(
      RatingCreateComponent,
      { job: this.job, candidate: candidate, user: this.currentUser },
      {
        showBackdrop: true,
        enableBackdropDismiss: true,
        cssClass: 'user-popover'
      }
    );
    popover.present({
      ev: candidate
    });
  }

  openMap() {
    let address = `${this.job.address.line1.replace(
      ' ',
      '+'
    )},+${this.job.address.line2.replace(
      ' ',
      '+'
    )},+${this.job.address.city.replace(' ', '+')}`;
    if (this.job.address.postalCode) {
      address = `${address},+${this.job.address.postalCode.replace(' ', '+')}`;
    }
    window.open(`https://www.google.co.za/maps/place/${address}`, '_system');
  }

  addToCalendar() {
    console.log('going to add to calendar');

    const startDate = moment(this.job.start, 'YYYYMMDD');
    const endDate = moment(this.job.end, 'YYYYMMDD');
    const startTime = moment(
      `${startDate.format('YYYYMMDD')}T${moment(this.job.start).format('HHmm')}`
    );
    const endTime = moment(
      `${startDate.format('YYYYMMDD')}T${moment(this.job.end).format('HHmm')}`
    );

    let hourDuration = moment.duration(endTime.diff(startTime));
    let dayDuration = moment.duration(endDate.diff(startDate));
    // let hours = hourDuration.asHours();
    // let minutes = hourDuration.asMinutes();
    let days = dayDuration.asDays() + 1;

    let jobDays: IJobCalendarEvent[] = [];

    for (let i = 0; i < days; i++) {
      let start: IJobCalendarDate = {
        // add 1 day for the 0 index. subtract 2 hours for GMT+2
        year: parseInt(
          moment(this.job.start)
            .add(i, 'day')
            .subtract(2, 'hour')
            .format('YYYY')
        ),
        month: parseInt(
          moment(this.job.start)
            .add(i, 'day')
            .subtract(2, 'hour')
            .format('MM')
        ),
        day: parseInt(
          moment(this.job.start)
            .add(i, 'day')
            .subtract(2, 'hour')
            .format('DD')
        ),
        hour: parseInt(
          moment(this.job.start)
            .add(i, 'day')
            .subtract(2, 'hour')
            .format('HH')
        ),
        minute: parseInt(
          moment(this.job.start)
            .add(i, 'day')
            .subtract(2, 'hour')
            .format('mm')
        )
      };
      let duration: IJobCalendarDuration = {
        hours: hourDuration.hours(),
        minutes: hourDuration.minutes()
      };
      let jobDay: IJobCalendarEvent = {
        productId: `${this.job.name} - ${this.job.address.line2}, ${this.job.address.city}`,
        title: `${this.job.name} - ${this.job.address.line2}, ${this.job.address.city}`,
        start: [start.year, start.month, start.day, start.hour, start.minute],
        duration: duration,
        description: this.job.comments,
        location: `${this.job.address.line1}, ${this.job.address.line2}, ${this.job.address.city}, ${this.job.address.province}, ${this.job.address.postalCode}`
      };
      jobDays.push(jobDay);
    }

    this.createEvents(jobDays);
  }

  createEvents(jobDays: IJobCalendarEvent[]) {
    console.log(jobDays);

    const { error, value } = ics.createEvents(jobDays);
    if (error) {
      console.log(error);
      return;
    }
    console.log(value);

    return this.generateICal(value);
  }

  generateICal(value) {
    const blob = new Blob([value], { type: 'text/calendar' });
    const url = window.URL.createObjectURL(blob);
    return (window.location.href = url);
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/shared/jobs/job-info.ts